import normalizePrice from './normalizePrice'

const localizePriceByCountry = (price, currencyCode, countryCode) => {
  let unitPrice = price.basePrice
  if (price.localizedPrices) {
    const localizedPrice = price.localizedPrices.find(v => v.country_codes.includes(countryCode))
    if (localizedPrice) {
      unitPrice = localizedPrice.unit_price
    }
  }

  return normalizePrice(unitPrice.amount, unitPrice.currency_code || currencyCode)
}

export default localizePriceByCountry
